@if (this.container() === 'button') {
  <cam-button [options]="{ circular: true }" (action)="this.open()">
    <cam-font-icon [name]="this.iconType()" type="sm"></cam-font-icon>
  </cam-button>
}
@if (this.container() === 'link') {
  <cam-button type="secondary" [size]="this.size()" [icon]="this.iconType()" (action)="this.open()">
    @if (this.label(); as label) {
      {{ label }}
    }
    @if (this.count() > 0) {
      <cam-badge [value]="this.count().toString()" type="primary" size="xs"></cam-badge>
    }
  </cam-button>
}

@if (!this.mobileDetection) {
  <cam-layout-full-panel
    [toggleState]="!!this.isFilterOpen"
    (closeEvent)="this.close()"
    [title]="'core.filter-displayer.title' | translate"
  >
    @if (this.isFilterOpen) {
      <ng-template [ngTemplateOutlet]="filterTemplate"></ng-template>
    }
  </cam-layout-full-panel>
}

<ng-template #filterTemplate>
  <cam-filter-container [form]="this.form()" (filtersSelected)="this.selected($event)"></cam-filter-container>
</ng-template>
